import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const ContentPanel = ({ page, content }) => {
  if (!page || !content) {
    return (
      <div className='playground-content-panel'>
        <div className='content-empty'>请选择一个页面查看内容</div>
      </div>
    );
  }

  // 从content_file路径中提取目录路径
  const getImageBasePath = () => {
    if (!page.content_file) return '';
    const lastSlashIndex = page.content_file.lastIndexOf('/');
    return page.content_file.substring(0, lastSlashIndex + 1);
  };

  const imageBasePath = getImageBasePath();

  return (
    <div className='playground-content-panel'>
      <div className='content-header'>
        <h1>{page.name}</h1>
      </div>
      <div className='content-body'>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
          components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || '');
              return !inline && match ? (
                <SyntaxHighlighter
                  style={vscDarkPlus}
                  language={match[1]}
                  PreTag='div'
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
            img({ node, src, alt, ...props }) {
              // 如果是相对路径，转换为绝对路径
              let imageSrc = src;
              if (src && !src.startsWith('http') && !src.startsWith('/')) {
                imageSrc = imageBasePath + src;
              }
              return <img src={imageSrc} alt={alt || ''} {...props} />;
            },
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default ContentPanel;
